import { css } from 'linaria';

export const nYtreeStyleText = css`
  && {
    width: 776px;
    margin-bottom: 24px;
    line-height: 28px;

    @media (--only-desktop) {
      width: 574px;
    }

    @media (--to-desktop) {
      width: 100%;
    }
  }
`;

export const nYtreeStyleGrid = css`
  && {
    grid-template-rows: 380px 380px;
    margin-bottom: 32px;

    @media (--only-tablet) {
      grid-gap: 24px;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: 216px 216px;
    }

    @media (--only-mobile) {
      grid-gap: 16px;
      grid-template-columns: 1fr;
      grid-template-rows: 117.5vw 67.5vw 67.5vw;
    }
  }
`;

export const nYtreeStyleImage = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--rounding-l);

  &:first-of-type {
    @media (--from-tablet) {
      grid-row: 1 / -1;
    }
  }
`;

export const nYtreeStyleButton = css`
  && {
    display: block;
    width: max-content;
    margin: 0 auto;
    text-align: center;

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;
